import React, { useEffect, useState, useRef, useMemo } from 'react';
// import { Adalicon } from '../Icons.jsx';
import DiscussionThread from './DiscussionThread.jsx';
import Button from '../../bootstrap/Button.jsx';
import LoadingIndicator from '../loading_indicator.jsx';
import Scrollbars from "react-custom-scrollbars-2";
import LexicalDiscussionEditor from '../richTextPlugins/LexicalDiscussionEditor.lazy.jsx';
import {
    live_discussion_get_threads_json_path,
    live_discussion_initiate_thread_path,
    live_discussion_mark_target_read_path
  } from '~/routes';

const sortDiscussions = (discussions) => {
    return discussions.sort((a, b) => {
        // sort by closed and id
        if (a.closed !== b.closed) {
            return a.closed ? 1 : -1;
        }
        return b.id - a.id;
    })
}

const ProjectDiscussion = ({target_id, permissions, target_type, person_id, unreadDiscussions, scrollStyle = {}, is_fund_staff, show_user_names, dashboard_gen2 = false} ) => {
    const [discussionThreads, setDiscussionThreads] = useState([]);
    // const [globalFilter, setGlobalFilter] = useState("");
    const [usersInfo, setUsersInfo] = useState({});
    const [loading, setLoading] = useState(false);
    // Use a single live thread at a time
    const [liveThread, setLiveThread] = useState(null);
    const [expandedThread, setExpandedThread] = useState(null);
    // Use a state to know if the initial discussion_id is set or not from query params
    const [initDiscussion, setInitDiscussion] = useState(false);
    const threadScroll = useRef(null)

    useEffect(() => {
        // Mark all threads as read so next reload will not have unread
        if (unreadDiscussions.length > 0){
            jQuery.post(live_discussion_mark_target_read_path({target_type: target_type, target_id: target_id}), {}, () => {
            })
        }
    }, [])

    useEffect(() => {
        setLoading(true);
        jQuery.getJSON(live_discussion_get_threads_json_path({project_id: target_id}))
                .success((res) => {
                    setDiscussionThreads(res.threads);
                    setUsersInfo(res.user_info);
                    setLoading(false);
                })
    }, [])

    useEffect(() => {
        // Only run once discussionThreads is set and the valid query param exist
        if (discussionThreads.length > 0 && !initDiscussion){
            const params = new URLSearchParams(window.location.search);
            const activeDiscussionStr = params.get("discussion_id");
            const activeDiscussion = Number.isNaN(parseInt(activeDiscussionStr)) ? 0 : parseInt(activeDiscussionStr);
            if (discussionThreads.map((t) => t.id).includes(activeDiscussion)){
                setLiveThread(activeDiscussion)
                setExpandedThread(activeDiscussion)
            }
            setInitDiscussion(true)
        }
    }, [initDiscussion, discussionThreads])

    useEffect(() => {
        if (discussionThreads.some(t => t.id === 'new')){
            threadScroll.current?.scrollToBottom();
        }
    }, [discussionThreads])

    useEffect(() => {
        // Scroll to bot when new thread initiated
        if (liveThread === (discussionThreads.at(-1) || {}).id){
            threadScroll.current?.scrollToBottom();
        }
    }, [liveThread])

    const initiateThread = () => {
        setDiscussionThreads((prev) => {
            if (!prev.some(t => t.id === 'new')){
                return [...prev, {id: 'new', messages: []}]
            }
            return prev
        })
    }

    const deleteThread = (id) => {
        setDiscussionThreads((prev) => sortDiscussions(prev.map(th => {
            if (th.id === id){
                return {
                    ...th,
                    closed: true
                }
            }
            return th
        })));
        setExpandedThread(null);
        window.ToastNotification({message: I18n.t('live_thread_closed'), horizontal: 'center', vertical: 'top', autoHideDuration: 5});
    }

    const reopenThread = (id) => {
        setDiscussionThreads((prev) => sortDiscussions(prev.map(th => {
            if (th.id === id){
                return {
                    ...th,
                    closed: false
                }
            }
            return th
        })));
        setExpandedThread(null);
        window.ToastNotification({message: I18n.t('live_thread_reopened'), horizontal: 'center', vertical: 'top', autoHideDuration: 5});
    }

    const discussionThreadContainer = () => {
        return (
        <div className='discussion-thread-container' style={{height: expandedThread ? '100%' : 'auto'}}>
            {
                loading ?
                <LoadingIndicator /> :
                discussionThreads.map((t) => 
                    t.id == 'new' ? 
                        <InitialThread 
                            {...{setLiveThread, setDiscussionThreads, loading, setLoading, target_id, setUsersInfo, threadScroll}}   
                        />
                    :
                    <DiscussionThread 
                        key={`thread-${t.id}`}
                        elementId={`thread-${t.id}`}
                        threadContent={t} 
                        live={liveThread === t.id} 
                        user_info={usersInfo[t.id] || {}}
                        project_id={target_id}
                        {...{setLiveThread, permissions, deleteThread, reopenThread, target_type, person_id, unreadDiscussions, setExpandedThread, expandedThread, is_fund_staff, show_user_names}} />
                )
            }
        </div>
        )
    }



    return (
        <div className='discussion-container advanced-component'>
            {/* <div className='react-table-search discussion-search'>
                <input
                    type="search"
                    className={'form-control input-sm flex-btn'}
                    placeholder={I18n.t('search')}
                    style={{height: '32px'}}
                    value={globalFilter || ""}
                    onChange={(e) => setGlobalFilter(e.target.value)}
                />
                <Adalicon type="search" className="search-icon" />
                <Button size='sm' type='primary' onClick={() => setSearch(true)}>{I18n.t('search')}</Button>
            </div> */}
            {expandedThread && <Button size='md' className='mt-1' onClick={() => setExpandedThread(null)}>
                <i className="fa-solid fa-arrow-left" style={{marginRight: '2px'}}></i>
                <span>{I18n.t('back_to_all_threads')}</span>
            </Button>}
            {/* Need logic improve, below code mean:
            - No discussion Threads -> render NoDiscussionThreads
            - Discussion threads -> Programme discussion -> always use Scrollbar with scrollType as it's in a widget
            - Discussion threads -> Project discussion -> Not expanded -> Scrollbar with 50vh to be same as latest activity tab
            - Discussion threads -> Project discussion -> Expanded -> No scrollbar needed for discussion threads level*/}
            {discussionThreads.length == 0 ? <NoDiscussionThreads /> : ((expandedThread || (target_type === 'programme' && dashboard_gen2)) ? discussionThreadContainer() : <Scrollbars ref={threadScroll} style={{height: '50vh', ...scrollStyle}}>{discussionThreadContainer()}</Scrollbars>)}
            {permissions.initiate_thread && !expandedThread && <Button onClick={initiateThread} size='md' type='primary' className='pull-left mt-1'>{I18n.t('start_new_thread')}</Button>}

        </div>
    )
}

const InitialThread = ({setDiscussionThreads, setLiveThread, loading, setLoading, target_id, setUsersInfo, threadScroll}) => {
    const [content, setContent] = useState('')
    
    const cancelEdit = () => {
        setDiscussionThreads(prev => prev.filter(t => t.id !== 'new'))
    }

    const filePermissions = useMemo(() => ({
        'reply_activity_feed_discussion': {
            id: target_id,
            type: 'project'
        }
    }), [])

    const initiateThreadWithMessage = () => {
        setLoading(true)
        jQuery.post(live_discussion_initiate_thread_path({project_id: target_id}), {content: content}, (data) => {
            setDiscussionThreads((prev) => {
                const newThreads = prev.filter(t => t.id !== 'new')
                return sortDiscussions([...newThreads, {id: data.discussion_id, messages: data.messages, first_message: data.messages[0] || {}, closed: false}])
            });
            setLiveThread(data.discussion_id);
            setUsersInfo((prev) =>  {
                return {...prev, [data.discussion_id]: data.user_info || {}}
            });
            setLoading(false);
        })
    }

    return (
        <div className='discussion-thread-content mb-1'>
            <div className='discussion-body'></div>
            <div className='discussion-footer'>
                <span style={{fontSize: '12px'}}>{I18n.t('new_thread')}</span>
                <LexicalDiscussionEditor
                    editorContainerStyle={{width: '100%', marginTop: '0.2rem'}}
                    value={content}
                    key='new-thread'
                    placeholder={I18n.t('type_your_message')} 
                    updateAnswer={(v) => setContent(v)}
                    onChange={(v) => setContent(v)} 
                    editorStyle={{backgroundColor: '#e5e6e8', minHeight: '60px', marginTop: '0.2rem'}}
                    reset={content === ''}
                    editing={true}
                    filePermissions={filePermissions}
                />
                <div className='chat-area-footer'>
                    {<Button type='default' size='sm' className='pull-left' onClick={cancelEdit}>
                        {I18n.t('cancel')}
                    </Button>}
                    <Button type='primary' size='sm' className='pull-right' onClick={initiateThreadWithMessage} disabled={loading || content.length == 0}>
                        {I18n.t('send')}
                    </Button>
                </div>
            </div>
        </div>
    )
}

const NoDiscussionThreads = () => {
    return (
        <div className="mb-1">
            {I18n.t('no_discussion_threads')}
        </div>
    )
}

export default ProjectDiscussion
